// import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
// import { Badge, Breadcrumb, Card, Col, Row } from 'react-bootstrap';
// import { Button } from 'primereact/button';
// import { DataTable } from 'primereact/datatable';
// import { Column } from 'primereact/column';
// import { InputText } from 'primereact/inputtext';
// import { Dropdown } from 'primereact/dropdown';
// import { Dialog } from 'primereact/dialog';
// import { Sidebar } from 'primereact/sidebar';
// import { IconField } from 'primereact/iconfield';
// import { InputIcon } from 'primereact/inputicon';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import config from '../../config';
// import { useAuth } from '../../context/AuthContext';
// import CustomToast from '../../components/CustomToast';
// import RolesPage from './RolesPage';
// import { formatRoleLabel } from '../../utils/roleLabels';
// import './iam.css';

// import { FiEdit2, FiUserCheck, FiUserX } from 'react-icons/fi';
// import { Tooltip } from 'primereact/tooltip';

// const NON_SYSTEM_NOTE = 'Saving a role updates that person\'s current role immediately.';

// function formatLastActive(value) {
//   if (!value) return '—';
//   const date = new Date(value);
//   if (Number.isNaN(date.getTime())) return '—';
//   return date.toLocaleString();
// }

// function errorMessage(error, fallback) {
//   return error?.response?.data?.message || fallback;
// }

// const IamAdmin = () => {
//   const navigate = useNavigate();
//   const toastRef = useRef(null);
//   const { accessToken, userId, permissions } = useAuth();
//   const actorPermissions = useMemo(() => (Array.isArray(permissions) ? permissions : []), [permissions]);
//   const canManage = actorPermissions.includes('iam:manage');
//   const [tab, setTab] = useState('users');

//   const [users, setUsers] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [page, setPage] = useState(0);
//   const [pageSize, setPageSize] = useState(15);
//   const [search, setSearch] = useState('');
//   const [roleFilter, setRoleFilter] = useState('all');
//   const [statusFilter, setStatusFilter] = useState('all');
//   const [loadingUsers, setLoadingUsers] = useState(false);

//   const [roles, setRoles] = useState([]);
//   const [catalog, setCatalog] = useState({ modules: [], outsideInventory: [] });
//   const [roleEditor, setRoleEditor] = useState(null);

//   const [userRoleDialog, setUserRoleDialog] = useState(null);
//   const [nextRole, setNextRole] = useState('');
//   const [drawer, setDrawer] = useState(null);

//   const notify = useCallback((severity, detail) => {
//     const summary = severity === 'error' ? 'Error' : 'Success';
//     toastRef.current?.show(severity, summary, detail);
//   }, []);

//   const request = useCallback(async (path, options = {}) => {
//     const response = await axios({
//       url: `${config.apiBASEURL}/iam${path}`,
//       headers: { Authorization: `Bearer ${accessToken}` },
//       ...options,
//     });
//     return response.data;
//   }, [accessToken]);

//   const loadRoles = useCallback(async () => {
//     const data = await request('/roles');
//     setRoles(data.roles || []);
//     return data.roles || [];
//   }, [request]);

//   const loadUsers = useCallback(async () => {
//     setLoadingUsers(true);
//     try {
//       const data = await request('/users', {
//         params: {
//           search,
//           role: roleFilter && roleFilter !== 'all' ? roleFilter : undefined,
//           status: statusFilter,
//           page: page + 1,
//           pageSize,
//         },
//       });
//       setUsers(data.users || []);
//       setTotal(data.total || 0);
//     } catch (err) {
//       notify('error', errorMessage(err, 'Could not load users'));
//     } finally {
//       setLoadingUsers(false);
//     }
//   }, [request, search, roleFilter, statusFilter, page, pageSize, notify]);

//   useEffect(() => {
//     if (!accessToken || !canManage) return;
//     loadUsers();
//   }, [accessToken, canManage, loadUsers]);

//   useEffect(() => {
//     if (!accessToken || !canManage) return;
//     request('/permissions')
//       .then((data) => setCatalog({ modules: data.modules || [], outsideInventory: data.outsideInventory || [] }))
//       .catch((err) => notify('error', errorMessage(err, 'Could not load permissions')));
//     loadRoles().catch((err) => notify('error', errorMessage(err, 'Could not load roles')));
//   }, [accessToken, canManage, request, loadRoles, notify]);

//   const roleOptions = useMemo(
//     () => [{ label: 'All roles', value: 'all' }, ...roles.map((role) => ({ label: formatRoleLabel(role.roleName), value: role.roleName }))],
//     [roles],
//   );
//   const assignableRoles = useMemo(
//     () => roles.filter((role) => !role.isSystem).map((role) => ({ label: formatRoleLabel(role.roleName), value: role.roleName })),
//     [roles],
//   );

//   const saveUserRole = async () => {
//     if (!userRoleDialog || !nextRole) return;
//     try {
//       await request(`/users/${userRoleDialog.userId}/role`, {
//         method: 'put',
//         data: { roleName: nextRole },
//       });
//       setUserRoleDialog(null);
//       notify('success', `${userRoleDialog.name} is now ${formatRoleLabel(nextRole)}.`);
//       await loadUsers();
//       await loadRoles();
//     } catch (err) {
//       notify('error', errorMessage(err, 'Could not change role'));
//     }
//   };

//   const setActive = async (user, active) => {
//     try {
//       await request(`/users/${user.userId}/active`, {
//         method: 'put',
//         data: { active },
//       });
//       notify('success', active ? `${user.name} is active.` : `${user.name} is inactive.`);
//       await loadUsers();
//     } catch (err) {
//       notify('error', errorMessage(err, 'Could not update status'));
//     }
//   };

//   const openDrawer = async (user) => {
//     setDrawer({ loading: true, user });
//     try {
//       const data = await request(`/users/${user.userId}`);
//       setDrawer({ loading: false, user: data.user, modules: data.modules || [], outsideInventory: data.outsideInventory || [] });
//     } catch (err) {
//       setDrawer(null);
//       notify('error', errorMessage(err, 'Could not load this user'));
//     }
//   };

//   const isSelf = (user) => Number(user.userId) === Number(userId);

//   return (
//     <Row className="body_content iam-page mx-0">
//       <Col>
//         <div className="d-flex justify-content-between align-items-center mb-3">
//           <Breadcrumb className="mb-0">
//             <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}>
//               <i className="pi pi-angle-left"></i> Back
//             </Breadcrumb.Item>
//             <Breadcrumb.Item active>Permissions</Breadcrumb.Item>
//           </Breadcrumb>
//           {tab === 'roles' && !roleEditor && (
//             <Button
//               label="Add Role"
//               icon="pi pi-plus"
//               severity="help"
//               disabled={!canManage}
//               onClick={() => setRoleEditor({ mode: 'create', role: null })}
//             />
//           )}
//         </div>

//         <div className="iam-tabs">
//           <Button
//             label="Users"
//             severity={tab === 'users' ? 'help' : 'secondary'}
//             outlined={tab !== 'users'}
//             onClick={() => setTab('users')}
//           />
//           <Button
//             label="Roles"
//             severity={tab === 'roles' ? 'help' : 'secondary'}
//             outlined={tab !== 'roles'}
//             onClick={() => setTab('roles')}
//           />
//         </div>

//         {tab === 'users' && (
//           <Card className="iam-roles-card mb-4">
//             <Card.Body>
//               <div className="iam-users-filters">
//                 <div className="iam-search">
//                   <i className="pi pi-search iam-search-icon" />
//                   <InputText
//                     className="iam-search-input"
//                     value={search}
//                     placeholder="Search name or email"
//                     onChange={(event) => { setSearch(event.target.value); setPage(0); }}
//                   />
//                 </div>  
//                 <Dropdown
//                   value={roleFilter}
//                   options={roleOptions}
//                   onChange={(event) => { setRoleFilter(event.value); setPage(0); }}
//                   placeholder="Role"
//                   className="iam-filter-dropdown"
//                   panelClassName="iam-dropdown-panel"
//                   aria-label="Filter by role"
//                 />
//                 <Dropdown
//                   value={statusFilter}
//                   options={[
//                     { label: 'All statuses', value: 'all' },
//                     { label: 'Active', value: 'active' },
//                     { label: 'Inactive', value: 'inactive' },
//                   ]}
//                   onChange={(event) => { setStatusFilter(event.value); setPage(0); }}
//                   className="iam-filter-dropdown"
//                   panelClassName="iam-dropdown-panel"
//                   aria-label="Filter by status"
//                 />
//               </div>
//               <DataTable
//                 value={users}
//                 lazy
//                 paginator
//                 rows={pageSize}
//                 first={page * pageSize}
//                 totalRecords={total}
//                 loading={loadingUsers}
//                 onPage={(event) => { setPage(event.page); setPageSize(event.rows); }}
//                 emptyMessage="No users match these filters."
//               >
//                 <Column header="Name" body={(user) => (
//                   <Button label={user.name} link onClick={() => openDrawer(user)} />
//                 )} />
//                 <Column field="email" header="Email" />
//                 <Column header="Role" body={(user) => formatRoleLabel(user.role)} />
//                 <Column header="Status" body={(user) => (
//                   <Badge bg={user.isActive ? 'success' : 'secondary'}>{user.isActive ? 'Active' : 'Inactive'}</Badge>
//                 )} />
//                 <Column header="Last active" body={(user) => formatLastActive(user.lastLoginAt)} />
//                 <Column header="Action" body={(user) => (
//                   <div className="d-flex gap-2">
//                     <Button
//                       icon="pi pi-user-edit"
//                       size="small"
//                       severity="help"
//                       outlined
//                       className="edit-role-btn"
//                       tooltip="Edit role"
//                       tooltipOptions={{ position: 'top' }}
//                       disabled={!canManage || isSelf(user)}
//                       onClick={() => { setUserRoleDialog(user); setNextRole(user.role); }}
//                     />
//                     <Button
//                       icon={user.isActive ? 'pi pi-user-minus' : 'pi pi-user-plus'}
//                       size="small"
//                       outlined
//                       severity={user.isActive ? 'danger' : 'success'}
//                       tooltip={user.isActive ? 'Deactivate user' : 'Activate user'}
//                       tooltipOptions={{ position: 'top' }}
//                       disabled={!canManage || (user.isActive && isSelf(user))}
//                       onClick={() => setActive(user, !user.isActive)}
//                     />
//                   </div>
//                 )} />
//               </DataTable>
//             </Card.Body>
//           </Card>
//         )}

//         {tab === 'roles' && (
//           <RolesPage
//             request={request}
//             roles={roles}
//             catalog={catalog}
//             canManage={canManage}
//             actorPermissions={actorPermissions}
//             editor={roleEditor}
//             setEditor={setRoleEditor}
//             reloadRoles={loadRoles}
//             notify={notify}
//           />
//         )}
//       </Col>

//       <Dialog
//         header="Edit role"
//         className="iam-role-dialog"
//         visible={Boolean(userRoleDialog)}
//         style={{ width: '26rem' }}
//         onHide={() => setUserRoleDialog(null)}
//       >
//         <p>{NON_SYSTEM_NOTE}</p>
//         <Dropdown
//           value={nextRole}
//           options={assignableRoles}
//           onChange={(event) => setNextRole(event.value)}
//           placeholder="Role"
//           className="iam-field-dropdown w-100 mb-3"
//           panelClassName="iam-dropdown-panel"
//           aria-label="Role"
//         />
//         <Button
//           label="Save role"
//           severity="help"
//           disabled={!nextRole || roles.find((role) => role.roleName === nextRole)?.isSystem}
//           onClick={saveUserRole}
//         />
//       </Dialog>

//       <Sidebar visible={Boolean(drawer)} position="right" style={{ width: '26rem' }} onHide={() => setDrawer(null)}>
//         {drawer && !drawer.loading && (
//           <>
//             <h5>{drawer.user.name}</h5>
//             <p className="mb-1">{drawer.user.email}</p>
//             <p>Role: <strong>{formatRoleLabel(drawer.user.role)}</strong></p>
//             <p>Last active: {formatLastActive(drawer.user.lastLoginAt)}</p>
//             <h6>Effective permissions</h6>
//             {(drawer.modules || []).map((module) => {
//               const keys = [];
//               (module.keys || []).forEach((item) => {
//                 if (drawer.user.permissionKeys.includes(item.key)) {
//                   keys.push({ label: item.label, description: item.description });
//                 }
//               });
//               (module.rows || []).forEach((row) => {
//                 Object.values(row.cells || {}).forEach((key) => {
//                   if (key && drawer.user.permissionKeys.includes(key)) {
//                     keys.push({ label: row.label, description: row.description });
//                   }
//                 });
//               });
//               if (!keys.length) return null;
//               const unique = [];
//               const seen = new Set();
//               keys.forEach((item) => {
//                 if (seen.has(item.label)) return;
//                 seen.add(item.label);
//                 unique.push(item);
//               });
//               return (
//                 <div key={module.id} className="mb-3">
//                   <strong>{module.title}</strong>
//                   {module.description && <p className="text-muted small mb-1">{module.description}</p>}
//                   <ul className="iam-baseline-list">
//                     {unique.map((item) => (
//                       <li key={item.label}>
//                         {item.label}
//                         {item.description && <div className="text-muted small">{item.description}</div>}
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               );
//             })}
//             <h6>Activity history</h6>
//             <p className="text-muted">Activity history will appear here.</p>
//           </>
//         )}
//       </Sidebar>

//       <CustomToast ref={toastRef} />
//     </Row>
//   );
// };

// export default IamAdmin;




import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Breadcrumb, Card, Col, Row } from 'react-bootstrap';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Sidebar } from 'primereact/sidebar';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import CustomToast from '../../components/CustomToast';
import RolesPage from './RolesPage';
import { formatRoleLabel } from '../../utils/roleLabels';
import './iam.css';
// import './iam-compact.css';

const NON_SYSTEM_NOTE = 'The new role applies as soon as you save it.';

const STATUS_OPTIONS = [
  { label: 'All statuses', value: 'all' },
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
];

/* The API has used a few different names for this field, so read whichever one
   comes back instead of showing "Never" for everyone. */
const LAST_ACTIVE_KEYS = [
  'lastLoginAt',
  'lastLogin',
  'last_login_at',
  'lastLoginDate',
  'lastActiveAt',
  'last_active_at',
  'lastActive',
  'lastSeenAt',
  'last_seen_at',
  'loginTime',
];

function lastActiveOf(user) {
  if (!user) return null;
  const key = LAST_ACTIVE_KEYS.find((name) => user[name]);
  return key ? user[key] : null;
}

const DATE_TIME_FORMAT = {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: true,
};

/* Renders as 10/26/2026, 10:24:41 AM */
function formatLastActive(value) {
  if (!value) return 'Never';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString('en-US', DATE_TIME_FORMAT);
}

/* Each role keeps the same colour everywhere, picked from a fixed light palette. */
const ROLE_TONES = ['indigo', 'teal', 'amber', 'rose', 'violet', 'sky', 'emerald'];

function roleTone(roleName) {
  if (!roleName) return 'slate';
  const key = String(roleName).toLowerCase();
  if (key.includes('ex-') || key.includes('former') || key.includes('inactive')) return 'slate';
  if (key.includes('admin') || key.includes('owner') || key.includes('super')) return 'violet';

  let hash = 0;
  for (let i = 0; i < key.length; i += 1) hash = (hash * 31 + key.charCodeAt(i)) % 9973;
  return ROLE_TONES[hash % ROLE_TONES.length];
}

function initials(name) {
  if (!name) return '?';
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
}

function errorMessage(error, fallback) {
  return error?.response?.data?.message || fallback;
}

/* Flattens a module's permission keys and rows into one de-duplicated list. */
function effectivePermissions(modules, grantedKeys) {
  const granted = new Set(grantedKeys || []);

  return (modules || [])
    .map((module) => {
      const seen = new Set();
      const items = [];

      const push = (label, description) => {
        if (!label || seen.has(label)) return;
        seen.add(label);
        items.push({ label, description });
      };

      (module.keys || []).forEach((item) => {
        if (granted.has(item.key)) push(item.label, item.description);
      });

      (module.rows || []).forEach((row) => {
        Object.values(row.cells || {}).forEach((key) => {
          if (key && granted.has(key)) push(row.label, row.description);
        });
      });

      return { ...module, items };
    })
    .filter((module) => module.items.length > 0);
}

const IamAdmin = () => {
  const navigate = useNavigate();
  const toastRef = useRef(null);
  const { accessToken, userId, permissions } = useAuth();
  const actorPermissions = useMemo(() => (Array.isArray(permissions) ? permissions : []), [permissions]);
  const canManage = actorPermissions.includes('iam:manage');
  const [tab, setTab] = useState('users');

  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [searchInput, setSearchInput] = useState('');
  const [search, setSearch] = useState('');
  const [roleFilter, setRoleFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [loadingUsers, setLoadingUsers] = useState(false);

  const [roles, setRoles] = useState([]);
  const [catalog, setCatalog] = useState({ modules: [], outsideInventory: [] });
  const [roleEditor, setRoleEditor] = useState(null);

  const [userRoleDialog, setUserRoleDialog] = useState(null);
  const [nextRole, setNextRole] = useState('');
  const [savingRole, setSavingRole] = useState(false);
  const [drawer, setDrawer] = useState(null);
  const [openGroups, setOpenGroups] = useState({});

  const notify = useCallback((severity, detail) => {
    const summary = severity === 'error' ? 'Error' : 'Success';
    toastRef.current?.show(severity, summary, detail);
  }, []);

  const request = useCallback(async (path, options = {}) => {
    const response = await axios({
      url: `${config.apiBASEURL}/iam${path}`,
      headers: { Authorization: `Bearer ${accessToken}` },
      ...options,
    });
    return response.data;
  }, [accessToken]);

  const loadRoles = useCallback(async () => {
    const data = await request('/roles');
    setRoles(data.roles || []);
    return data.roles || [];
  }, [request]);

  const loadUsers = useCallback(async () => {
    setLoadingUsers(true);
    try {
      const data = await request('/users', {
        params: {
          search,
          role: roleFilter && roleFilter !== 'all' ? roleFilter : undefined,
          status: statusFilter,
          page: page + 1,
          pageSize,
        },
      });
      setUsers(data.users || []);
      setTotal(data.total || 0);
    } catch (err) {
      notify('error', errorMessage(err, 'Could not load users'));
    } finally {
      setLoadingUsers(false);
    }
  }, [request, search, roleFilter, statusFilter, page, pageSize, notify]);

  /* Waits for a pause in typing so the list is not re-fetched on every keystroke. */
  useEffect(() => {
    const timer = setTimeout(() => {
      setSearch(searchInput.trim());
      setPage(0);
    }, 350);
    return () => clearTimeout(timer);
  }, [searchInput]);

  useEffect(() => {
    if (!accessToken || !canManage) return;
    loadUsers();
  }, [accessToken, canManage, loadUsers]);

  useEffect(() => {
    if (!accessToken || !canManage) return;
    request('/permissions')
      .then((data) => setCatalog({ modules: data.modules || [], outsideInventory: data.outsideInventory || [] }))
      .catch((err) => notify('error', errorMessage(err, 'Could not load permissions')));
    loadRoles().catch((err) => notify('error', errorMessage(err, 'Could not load roles')));
  }, [accessToken, canManage, request, loadRoles, notify]);

  const roleOptions = useMemo(
    () => [
      { label: 'All roles', value: 'all' },
      ...roles.map((role) => ({ label: formatRoleLabel(role.roleName), value: role.roleName })),
    ],
    [roles],
  );

  const assignableRoles = useMemo(
    () => roles
      .filter((role) => !role.isSystem)
      .map((role) => ({ label: formatRoleLabel(role.roleName), value: role.roleName })),
    [roles],
  );

  const filtersActive = Boolean(searchInput) || roleFilter !== 'all' || statusFilter !== 'all';

  const clearFilters = () => {
    setSearchInput('');
    setRoleFilter('all');
    setStatusFilter('all');
    setPage(0);
  };

  const saveUserRole = async () => {
    if (!userRoleDialog || !nextRole) return;
    setSavingRole(true);
    try {
      await request(`/users/${userRoleDialog.userId}/role`, {
        method: 'put',
        data: { roleName: nextRole },
      });
      setUserRoleDialog(null);
      notify('success', `${userRoleDialog.name} is now ${formatRoleLabel(nextRole)}.`);
      await loadUsers();
      await loadRoles();
    } catch (err) {
      notify('error', errorMessage(err, 'Could not change role'));
    } finally {
      setSavingRole(false);
    }
  };

  const setActive = async (user, active) => {
    try {
      await request(`/users/${user.userId}/active`, {
        method: 'put',
        data: { active },
      });
      notify('success', active ? `${user.name} is active.` : `${user.name} is inactive.`);
      await loadUsers();
    } catch (err) {
      notify('error', errorMessage(err, 'Could not update status'));
    }
  };

  const openDrawer = async (user) => {
    setOpenGroups({});
    setDrawer({ loading: true, user });
    try {
      const data = await request(`/users/${user.userId}`);
      setDrawer({
        loading: false,
        user: data.user,
        modules: data.modules || [],
        outsideInventory: data.outsideInventory || [],
      });
    } catch (err) {
      setDrawer(null);
      notify('error', errorMessage(err, 'Could not load this user'));
    }
  };

  const isSelf = (user) => Number(user.userId) === Number(userId);

  const drawerPermissions = useMemo(
    () => (drawer && !drawer.loading
      ? effectivePermissions(drawer.modules, drawer.user?.permissionKeys)
      : []),
    [drawer],
  );

  const drawerPermissionCount = useMemo(
    () => drawerPermissions.reduce((sum, module) => sum + module.items.length, 0),
    [drawerPermissions],
  );

  /* ---------- column bodies ---------- */

  const userBody = (user) => (
    <button type="button" className="iam-user-cell" onClick={() => openDrawer(user)}>
      <span className={`iam-avatar${user.isActive ? '' : ' is-muted'}`} aria-hidden="true">
        {initials(user.name)}
      </span>
      <span className="iam-user-text">
        <span className="iam-user-name">
          {user.name}
          {isSelf(user) && <span className="iam-you">You</span>}
        </span>
        <span className="iam-user-email">{user.email}</span>
      </span>
    </button>
  );

  const roleBody = (user) => (
    <span className={`iam-chip tone-${roleTone(user.role)}`}>{formatRoleLabel(user.role)}</span>
  );

  const statusBody = (user) => (
    <span className={`iam-status ${user.isActive ? 'is-active' : 'is-inactive'}`}>
      <span className="iam-dot" aria-hidden="true" />
      {user.isActive ? 'Active' : 'Inactive'}
    </span>
  );

  const lastActiveBody = (user) => {
    const value = lastActiveOf(user);
    return (
      <span className={`iam-last-active${value ? '' : ' is-never'}`}>
        {formatLastActive(value)}
      </span>
    );
  };

  const actionBody = (user) => (
    <div className="iam-row-actions">
      <Button
        icon="pi pi-user-edit"
        text
        severity="info"
        className="iam-action-btn"
        aria-label={`Change role for ${user.name}`}
        tooltip={isSelf(user) ? 'You cannot change your own role' : 'Change role'}
        tooltipOptions={{ position: 'top' }}
        disabled={!canManage || isSelf(user)}
        onClick={() => { setUserRoleDialog(user); setNextRole(user.role); }}
      />
      <Button
        icon={user.isActive ? 'pi pi-user-minus' : 'pi pi-user-plus'}
        text
        severity={user.isActive ? 'danger' : 'success'}
        className="iam-action-btn"
        aria-label={user.isActive ? `Deactivate ${user.name}` : `Activate ${user.name}`}
        tooltip={user.isActive && isSelf(user) ? 'You cannot deactivate yourself' : (user.isActive ? 'Deactivate' : 'Activate')}
        tooltipOptions={{ position: 'top' }}
        disabled={!canManage || (user.isActive && isSelf(user))}
        onClick={() => setActive(user, !user.isActive)}
      />
    </div>
  );

  const emptyMessage = (
    <div className="iam-empty">
      <i className="pi pi-users" aria-hidden="true" />
      <p>{filtersActive ? 'No users match these filters.' : 'No users yet.'}</p>
      {filtersActive && <Button label="Clear filters" link size="small" onClick={clearFilters} />}
    </div>
  );

  return (
    <Row className="body_content iam-page iam-compact mx-0">
      <Col>
        <header className="iam-topbar">
          <Breadcrumb className="mb-0 iam-crumbs">
            <Breadcrumb.Item onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}>
              <i className="pi pi-angle-left" /> Back
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Permissions</Breadcrumb.Item>
          </Breadcrumb>

          <div className="iam-topbar-right">
            <div className="iam-segmented" role="tablist" aria-label="Permissions sections">
              <button
                type="button"
                role="tab"
                aria-selected={tab === 'users'}
                className={tab === 'users' ? 'is-selected' : ''}
                onClick={() => setTab('users')}
              >
                <i className="pi pi-users" aria-hidden="true" />
                Users
              </button>
              <button
                type="button"
                role="tab"
                aria-selected={tab === 'roles'}
                className={tab === 'roles' ? 'is-selected' : ''}
                onClick={() => setTab('roles')}
              >
                <i className="pi pi-shield" aria-hidden="true" />
                Roles
              </button>
            </div>

            {tab === 'roles' && !roleEditor && (
              <Button
                label="Add role"
                icon="pi pi-plus"
                severity="help"
                size="small"
                disabled={!canManage}
                onClick={() => setRoleEditor({ mode: 'create', role: null })}
                style={{ padding: '0.5rem 1rem' }}
              />
            )}
          </div>
        </header>

        {tab === 'users' && (
          <Card className="iam-roles-card iam-card">
            <Card.Body className="p-0">
              {/* search | role | status on one line, with an optional clear button */}
              <div className={`iam-toolbar${filtersActive ? ' has-clear' : ''}`}>
                <div className="iam-search">
                  <i className="pi pi-search iam-search-icon" aria-hidden="true" />
                  <InputText
                    className="iam-search-input"
                    value={searchInput}
                    placeholder="Search name or email"
                    aria-label="Search users"
                    onChange={(event) => setSearchInput(event.target.value)}
                  />
                  {searchInput && (
                    <button
                      type="button"
                      className="iam-search-clear"
                      aria-label="Clear search"
                      onClick={() => setSearchInput('')}
                    >
                      <i className="pi pi-times" />
                    </button>
                  )}
                </div>

                <Dropdown
                  value={roleFilter}
                  options={roleOptions}
                  onChange={(event) => { setRoleFilter(event.value); setPage(0); }}
                  placeholder="Role"
                  className="iam-filter-dropdown"
                  panelClassName="iam-dropdown-panel"
                  aria-label="Filter by role"
                />
                <Dropdown
                  value={statusFilter}
                  options={STATUS_OPTIONS}
                  onChange={(event) => { setStatusFilter(event.value); setPage(0); }}
                  className="iam-filter-dropdown"
                  panelClassName="iam-dropdown-panel"
                  aria-label="Filter by status"
                />

                {filtersActive && (
                  <Button
                    label="Clear"
                    icon="pi pi-filter-slash"
                    text
                    className="iam-clear-btn"
                    onClick={clearFilters}
                  />
                )}
              </div>

              <DataTable
                value={users}
                lazy
                paginator
                stripedRows
                rows={pageSize}
                first={page * pageSize}
                totalRecords={total}
                loading={loadingUsers}
                rowsPerPageOptions={[10, 15, 25, 50]}
                paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink NextPageLink LastPageLink"
                currentPageReportTemplate="{first}–{last} of {totalRecords} users"
                onPage={(event) => { setPage(event.page); setPageSize(event.rows); }}
                emptyMessage={emptyMessage}
                className="iam-table"
                rowClassName={(user) => (user.isActive ? '' : 'iam-row-inactive')}
              >
                <Column header="User" body={userBody} style={{ minWidth: '16rem' }} />
                <Column header="Role" body={roleBody} style={{ width: '13rem' }} />
                <Column header="Status" body={statusBody} style={{ width: '8.5rem' }} />
                <Column header="Last active" body={lastActiveBody} style={{ width: '13rem' }} />
                <Column header="Actions" body={actionBody} style={{ width: '7.5rem' }} alignHeader="center" bodyClassName="iam-actions-cell" />
              </DataTable>
            </Card.Body>
          </Card>
        )}

        {tab === 'roles' && (
          <RolesPage
            request={request}
            roles={roles}
            catalog={catalog}
            canManage={canManage}
            actorPermissions={actorPermissions}
            editor={roleEditor}
            setEditor={setRoleEditor}
            reloadRoles={loadRoles}
            notify={notify}
          />
        )}
      </Col>

      <Dialog
        header="Change role"
        className="iam-role-dialog iam-compact-dialog"
        visible={Boolean(userRoleDialog)}
        style={{ width: 'min(26rem, 94vw)' }}
        draggable={false}
        onHide={() => setUserRoleDialog(null)}
        footer={(
          <div className="iam-dialog-footer">
            <Button label="Cancel" text size="small" onClick={() => setUserRoleDialog(null)} />
            <Button
              label="Save role"
              severity="help"
              size="small"
              loading={savingRole}
              disabled={
                !nextRole
                || nextRole === userRoleDialog?.role
                || roles.find((role) => role.roleName === nextRole)?.isSystem
              }
              onClick={saveUserRole}
            />
          </div>
        )}
      >
        {userRoleDialog && (
          <>
            <div className="iam-dialog-user">
              <span className="iam-avatar" aria-hidden="true">{initials(userRoleDialog.name)}</span>
              <span className="iam-user-text">
                <span className="iam-user-name">{userRoleDialog.name}</span>
                <span className="iam-user-email">{userRoleDialog.email}</span>
              </span>
            </div>

            <div className="iam-field">
              <label htmlFor="iam-next-role">Role</label>
              <Dropdown
                inputId="iam-next-role"
                value={nextRole}
                options={assignableRoles}
                onChange={(event) => setNextRole(event.value)}
                placeholder="Select a role"
                className="iam-field-dropdown w-100"
                panelClassName="iam-dropdown-panel"
              />
            </div>

            <p className="iam-hint">{NON_SYSTEM_NOTE}</p>
          </>
        )}
      </Dialog>

      <Sidebar
        visible={Boolean(drawer)}
        position="right"
        style={{ width: 'min(28rem, 100vw)' }}
        className="iam-drawer"
        onHide={() => setDrawer(null)}
        // header={<span className="iam-drawer-title">User details</span>}
      >
        {drawer?.loading && (
          <div className="iam-drawer-loading">
            <ProgressSpinner style={{ width: '2.25rem', height: '2.25rem' }} strokeWidth="4" />
          </div>
        )}

        {drawer && !drawer.loading && (
          <>
            <div className="iam-hero">
              <span className="iam-hero-avatar" aria-hidden="true">{initials(drawer.user.name)}</span>
              <h5 className="iam-hero-name">{drawer.user.name}</h5>
              <a className="iam-hero-email" href={`mailto:${drawer.user.email}`}>{drawer.user.email}</a>
              <div className="iam-hero-tags">
                <span className={`iam-chip tone-${roleTone(drawer.user.role)}`}>
                  {formatRoleLabel(drawer.user.role)}
                </span>
                <span className={`iam-status-pill ${drawer.user.isActive === false ? 'is-inactive' : 'is-active'}`}>
                  <span className="iam-dot" aria-hidden="true" />
                  {drawer.user.isActive === false ? 'Inactive' : 'Active'}
                </span>
              </div>
            </div>

            <dl className="iam-stats">
              <div className="iam-stat">
                <dt>Permissions</dt>
                <dd>{drawerPermissionCount}</dd>
              </div>
              <div className="iam-stat">
                <dt>Modules</dt>
                <dd>{drawerPermissions.length}</dd>
              </div>
              <div className="iam-stat">
                <dt>Last active</dt>
                <dd className={lastActiveOf(drawer.user) ? '' : 'is-empty'}>
                  {formatLastActive(lastActiveOf(drawer.user))}
                </dd>
              </div>
            </dl>

            <section className="iam-drawer-section">
              <div className="iam-section-head">
                <h6>Permissions</h6>
                {drawerPermissionCount > 0 && (
                  <span>{drawerPermissionCount} granted</span>
                )}
              </div>

              {drawerPermissions.length === 0 && (
                <div className="iam-drawer-empty">
                  <i className="pi pi-lock" aria-hidden="true" />
                  <p>This role has no permissions yet.</p>
                </div>
              )}

              {drawerPermissions.map((module) => {
                const open = openGroups[module.id] !== false;
                return (
                  <div key={module.id} className={`iam-perm-group${open ? ' is-open' : ''}`}>
                    <button
                      type="button"
                      className="iam-group-head"
                      aria-expanded={open}
                      onClick={() => setOpenGroups((prev) => ({ ...prev, [module.id]: !open }))}
                    >
                      <span className="iam-group-title">{module.title}</span>
                      <span className="iam-group-count">{module.items.length}</span>
                      <i className="pi pi-chevron-down iam-group-chevron" aria-hidden="true" />
                    </button>

                    {open && (
                      <>
                        {module.description && <p className="iam-group-desc">{module.description}</p>}
                        <ul className="iam-perm-list">
                          {module.items.map((item) => (
                            <li key={item.label}>
                              <i className="pi pi-check" aria-hidden="true" />
                              <span className="iam-perm-text">
                                <span>{item.label}</span>
                                {item.description && <span className="iam-muted iam-small">{item.description}</span>}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                  </div>
                );
              })}
            </section>

            <section className="iam-drawer-section">
              <div className="iam-section-head">
                <h6>Activity history</h6>
              </div>
              <div className="iam-drawer-empty">
                <i className="pi pi-clock" aria-hidden="true" />
                <p>No activity recorded yet.</p>
              </div>
            </section>
          </>
        )}

        {drawer && !drawer.loading && canManage && (
          <div className="iam-drawer-footer">
            <Button
              label="Change role"
              icon="pi pi-user-edit"
              outlined
              severity="help"
              size="small"
              disabled={isSelf(drawer.user)}
              onClick={() => {
                setUserRoleDialog(drawer.user);
                setNextRole(drawer.user.role);
                setDrawer(null);
              }}
            />
            <Button
              label={drawer.user.isActive === false ? 'Activate' : 'Deactivate'}
              icon={drawer.user.isActive === false ? 'pi pi-user-plus' : 'pi pi-user-minus'}
              outlined
              severity={drawer.user.isActive === false ? 'success' : 'danger'}
              size="small"
              disabled={drawer.user.isActive !== false && isSelf(drawer.user)}
              onClick={async () => {
                const next = drawer.user.isActive === false;
                await setActive(drawer.user, next);
                setDrawer((current) => (current
                  ? { ...current, user: { ...current.user, isActive: next } }
                  : current));
              }}
            />
          </div>
        )}
      </Sidebar>

      <CustomToast ref={toastRef} />
    </Row>
  );
};

export default IamAdmin;
